/** 
 Copyright Highway9 Networks Inc. 
 */
import { EdgePool } from "~/types/EdgePool";
import APIService from "./APIServices";
import { authenticationService } from "./authentication-service";
import { Edge } from "~/types/edge";
import { Device } from "~/types/device";
import { EdgeUpgrade } from "~/types/AvailableUpgrades";
import { Tunnel } from "~/types/Tunnel";

export const edgeAPI = new APIService<Edge>("edges");
const edgePoolAPI = new APIService<EdgePool>("edgePools");
const deviceAPI = new APIService<Device>("devices");

export const edgeService = {
  getEdges: edgeAPI.getAll,
  createEdge: edgeAPI.create,
  deleteEdges: edgeAPI.delete,
  updateEdge: edgeAPI.update,
  getMetrics: edgeAPI.getMetrics,
  getConnectedDevicesCount: deviceAPI.getMetrics,
  getAggregateMetrics: edgeAPI.getAggregateMetrics,
  getEdgePool: edgePoolAPI.getAll,
  addEdgePool: edgePoolAPI.create,
  updateEdgePool: edgePoolAPI.update,
  deleteEdgePool: edgePoolAPI.delete,
  getEdgeUpgrades: async () => {
    const response = await edgeAPI.get<EdgeUpgrade[]>("availableUpgrades") // Assuming this endpoint returns the available upgrades for edges 
    return response
  },
  getTunnels: async (edgeId: string) => {
    const response = await edgeAPI.get<Tunnel[]>(`${edgeId}/support`) // Assuming this endpoint returns the tunnels
    return response
  },
  addTunnel: async (edgeId: string, data: Tunnel) => {
    const response = await edgeAPI.post<Tunnel>(`${edgeId}/support`, data) // Assuming this endpoint adds the tunnels
    return response
  },
  updateTunnel: async (edgeId: string, id: string, data: Tunnel) => {
    const response = await edgeAPI.put<Tunnel>(`${edgeId}/support/${id}`, data) // Assuming this endpoint updates the tunnels
    return response
  },
  deleteTunnel: async (edgeId: string, id: string) => {
    const response = await edgeAPI.delete(`${edgeId}/support/${id}`) // Assuming this endpoint deletes the tunnels
    return response
  },
  getPartnerRadioManagers: async () => {
    const response = await fetch("/api/v1/orch/partnerRadioManager/query", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticationService.currentUserValue?.token}`,
      },
      body: JSON.stringify({}),
    });
    return response.json();
  },
};
